import {IOrder} from '@/models/IOrder';
import {apiClient} from '@/services/base/BaseService';

export async function getListOrders(organizationId: number, shopId: number): Promise<IOrder[]> {
    const url = `organizations/${organizationId}/shops/${shopId}/orders`;
    const response = await apiClient.get(url);
    let orders = [];
    if (response.status === 200) {
        orders = response.data.data;
    }
    return orders;
}

export async function exportOrderToSheet(organizationId: number, shopId: number, orders: any) {
    const url = `organizations/${organizationId}/shops/${shopId}/orders/actions/export-orders-to-sheet`;
    const response = await apiClient.post(url, {
        orders,
    });
    return response.status === 200;
}

export async function exportOrderToExcelFile(organizationId: number, shopId: number, orders: any) {
    const url = `organizations/${organizationId}/shops/${shopId}/orders/actions/export-orders-to-excel-file`;
    const response = await apiClient.post(url, {
        orders,
    }, {responseType: 'arraybuffer'});

    const currentDate = new Date();
    const date = currentDate.getDate();
    const month = currentDate.getMonth();
    const year = currentDate.getFullYear();
    const time = currentDate.getTime();
    const dateTimeString = date + '-' + (month + 1) + '-' + year + '-' + time;

    const blob = new Blob([response.data], {type: 'application/xlsx'});
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'orders-' + dateTimeString + '.xlsx';
    link.click();
    return response.status === 200;
}
